import React from "react";

function AccountRemoval() {
  return (
    <div style={{ padding: "2rem", backgroundColor: "#000", color: "#fff" }}>
      <h1>Account Removal Request</h1>
      <p>
        If you wish to delete your account, please send an email to{" "}
        <strong>tech@khaolam.com</strong> with the subject line{" "}
        <em>"Account Removal"</em>. In the email, include your User ID, which
        you can find on the landing page or in the settings menu of the game.
      </p>
      <p>
        Feel free to include a screenshot of your User ID to help us process your request. 
        Once we receive your email, we will process your account
        removal as soon as possible.
      </p>
    </div>
  );
}

export default AccountRemoval;